export default __webpack_public_path__ + "static/media/download_file.6adc6966.svg";